import type { VpIconName } from '@vtmn-play/react/headless';
import type { PropsWithChildren } from 'react';
import type {
  InteractionType,
} from '~/model/InteractionType';
import { useTranslations } from 'next-intl';
import { FormatedDateslot } from '~/components/commons/FormatedDateslot/FormatedDateslot';
import { InteractionOption } from '~/components/commons/InteractionOption/InteractionOption';
import { TimeLeft } from '~/components/commons/TimeLeft/TimeLeft';
import { checkIsSelection } from '~/components/Interaction/utils';

export const InteractionSummary = ({
  children,
  interaction,
}: PropsWithChildren<{
  interaction: InteractionType;
}>) => {
  const isForChildren = interaction.for_children;
  const interactionEndAt = interaction.end_at;
  const interactionEventStartAt = interaction.event_start_at;
  const interactionEventEndAt = interaction.event_end_at;
  const contributionsCount = interaction.contributors_count;
  const isSelection = checkIsSelection(interaction);
  const userSubmissionsCount = interaction.current_user_contribution?.count_per_status?.submitted;
  const t = useTranslations('INTERACTION');

  return (
    <div
      data-testid="interaction-summary"
      className="interaction-summary__options"
    >
      <InteractionOption
        icon="time"
        label={<TimeLeft endAt={interactionEndAt} />}
      />
      {isSelection && (
        <InteractionOption
          icon="calendar-date"
          label={(
            <FormatedDateslot
              start={interactionEventStartAt}
              end={interactionEventEndAt}
              displayDay
            />
          )}
        />
      )}
      {isForChildren && (
        <InteractionOption
          icon="emotion-laugh"
          label={t('FOR_CHILDREN')}
        />
      )}
      {contributionsCount >= 0 && (
        <InteractionOption
          icon="user"
          label={t('CONTRIBUTOR', {
            count: contributionsCount,
          })}
        />
      )}
      {userSubmissionsCount > 1 && (
        <InteractionOption
          icon={'task' as VpIconName}
          label={`${t('HAS_CONTRIBUTED', {
            count: userSubmissionsCount,
          })}`}
        />
      )}
      {children}
    </div>
  );
};
